import React, { useEffect, useState, useRef } from "react";
import { ReactComponent as Logo } from "../logo.svg";

import getUserManager from "../../../authentication/user-manager";
import LoginPage from "../login-page";

import { connect } from "react-redux";
import { changeLang, changeTheme } from "../../../redux/actions/report-actions.js";
import { theme_dark, theme_light } from "../../../commonConstants";
import pack from "../../../../package.json";
import referenceData from "../../../reference-data.json";

import HOC from "../../../hoc";
import setTheme from "../../../utils/setTheme";
import { ReactComponent as SvgInfo } from "../../../assets/info.svg";
import { useNavigate } from "react-router-dom";
import { ReactComponent as SvgOpen } from "../../../assets/folder-open-outline.svg";

import "./home-page.scss";
import prepareRecordsFilesService from "../../../services/RecordFilesService.js";
import { Spinner, ErrorIndicator } from "../../../components/state-indicators";
import prepareDataService from "../../../services/prepareDataServices.js";
import ButtonIcon from "../../../components/ui/ButtonIcon/ButtonIcon.jsx";
import getUrls from "../../../api/index.js";
import CloseBtn from "../../../components/close-btn/app-close-btn.jsx";

const { withLocalization } = HOC;
const HomePage = props => {
    const { loc, user, lang, theme, anonymousMode, basepath, useCloseAppFile } = props;

    const recordsService = useRef();
    const dataService = useRef();

    const navigate = useNavigate();
    const userManager = getUserManager();

    const [records, setRecords] = useState([]);
    const [dataDirectory, setDataDirectory] = useState();
    const [loadingRecords, setLoadingRecords] = useState(false);
    const [errorRecords, setErrorRecords] = useState(false);

    const [apiInfo, setApiInfo] = useState();
    const [SACR_config, setSACR_config] = useState();

    useEffect(() => {
        recordsService.current = prepareRecordsFilesService(basepath);
        dataService.current = prepareDataService(basepath); // Используется только для получения инфы о продуктах

        const requestRecords = async () => {
            try {
                setLoadingRecords(true);
                const info = await recordsService.current.getRecordInfos();
                setDataDirectory(info.DataDirectory);
                setRecords(info.Records);
            } catch {
                setErrorRecords(true);
            } finally {
                setLoadingRecords(false);
            }
        };
        const requestApiInfo = async () => {
            try {
                const prodInfo = await dataService.current.getProductInfo();
                setApiInfo(prodInfo);
            } catch (err) {
                console.error(err); // eslint-disable-line
            }
        };
        async function fetchSettings() {
            return fetch(getUrls(basepath).urlGetSettings).then(resp => {
                if (!resp.ok) throw Error("Error! Fetch settings request status is not Ok!");
                return resp.json();
            });
        }

        if (basepath !== undefined) {
            if (anonymousMode) {
                requestRecords();
                fetchSettings().then(setts => {
                    const { SACR_config: _SACR } = setts ?? {};
                    setSACR_config(_SACR);
                });
            } else {
                requestApiInfo();
            }
        }
    }, [basepath, anonymousMode]);

    if (!anonymousMode && (!user || user.expired)) {
        return <LoginPage {...{ anonymousMode }} />;
    }

    const onReferenceClick = () => {
        navigate("/reference");
    };

    const onSelectFileClick = filename => {
        if (!filename || filename === "default") {
            return;
        }
        navigate(`/report?record=${filename}`);
    };

    setTheme(theme);

    const AppCloseBtn =
        SACR_config || (anonymousMode && useCloseAppFile) ? (
            <CloseBtn {...{ basepath, anonymousMode, useCloseAppFile, SACR_config, loc }} />
        ) : null;

    return (
        <div className="ecg-report-component">
            <div className="home-page">
                {<div className="home-page__toolbar home-page__toolbar_close">{AppCloseBtn}</div>}
                <div className="home-page__toolbar">
                    <div className="controls-group switch-controls">
                        <div className="group ">
                            <label className={"label button" + (lang === "RU" ? " active" : "")}>
                                <input
                                    type="radio"
                                    name="appLang"
                                    value="RU"
                                    checked={lang === "RU"}
                                    onChange={() => {
                                        props.changeLang("RU");
                                    }}></input>
                                RU
                            </label>
                            <label className={"label button" + (lang === "EN" ? " active" : "")}>
                                <input
                                    type="radio"
                                    name="appLang"
                                    value="EN"
                                    checked={lang === "EN"}
                                    onChange={() => {
                                        props.changeLang("EN");
                                    }}></input>
                                EN
                            </label>
                        </div>
                    </div>
                    <div className="controls-group switch-controls">
                        <div className="group">
                            <label className={"label button" + (theme === theme_light ? " active" : "")}>
                                <input
                                    type="radio"
                                    name="appTheme"
                                    value={theme_light}
                                    checked={theme === theme_light}
                                    onChange={() => {
                                        props.changeTheme(theme_light);
                                    }}></input>
                                {loc("theme.light").toUpperCase()}
                            </label>
                            <label className={"label button" + (theme === theme_dark ? " active" : "")}>
                                <input
                                    type="radio"
                                    name="appTheme"
                                    value={theme_dark}
                                    checked={theme === theme_dark}
                                    onChange={() => {
                                        props.changeTheme(theme_dark);
                                    }}></input>
                                {loc("theme.dark").toUpperCase()}
                            </label>
                        </div>
                    </div>
                </div>

                <div className="home-page__content">
                    <div className="home-page__logo-container">
                        <Logo />
                    </div>
                    <h1 className="home-page__header">
                        <div>{lang === "RU" ? referenceData.product.programName : referenceData.product.programNameEn} </div>
                    </h1>

                    <div className="home-page__user_name">{user?.profile?.display_name}</div>

                    {!anonymousMode && (
                        <div className="home-page__auth-controls">
                            <button type="button" className="button button-ok" onClick={() => userManager.signoutRedirect()}>
                                {loc("pages.login.signOutBtn")}
                            </button>
                        </div>
                    )}

                    {anonymousMode &&
                        (errorRecords ? (
                            <ErrorIndicator
                                fillParent={false}
                                verySmall
                                descriptionComponent={<span>{loc("errors.dataapi.recordsInfo")}</span>}
                            />
                        ) : loadingRecords ? (
                            <Spinner fillParent={false} verySmall />
                        ) : (
                            <div className="controls-group open-record">
                                <div className="open-record__data-directory">
                                    <span className="data-directory__label">{loc("pages.home.workingDirectory")}</span>
                                    <span className="data-directory__value">{dataDirectory}</span>
                                </div>
                                <div className="open-record__records">
                                    <SvgOpen />
                                    <select
                                        defaultValue="default"
                                        className="ctrl-input"
                                        onChange={({ target: { value } }) => onSelectFileClick(value)}>
                                        <option disabled value="default">
                                            {loc("pages.home.chooseFile")}
                                        </option>
                                        {records.map(({ FileName }) => (
                                            <option value={FileName} key={FileName}>
                                                {FileName}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        ))}
                </div>

                <div className="home-page__footer">
                    <ButtonIcon className="button-reference" text={loc("buttons.reference")} onClick={onReferenceClick}>
                        <SvgInfo />
                    </ButtonIcon>

                    {anonymousMode ? (
                        <div className="version ">{`${loc("version")} ${referenceData.product.programVersion}`}</div>
                    ) : (
                        <>
                            <div className="version">{`frontend: ${pack.version}`}</div>
                            <div className="version">{`backend: ${apiInfo?.backend?.Version ?? ""}`}</div>
                            <div className="version">{`data API: ${apiInfo?.dataApi?.Name ?? ""} ${apiInfo?.dataApi?.Version ?? ""}`}</div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        user: state.oidc.user,
        lang: state.reportApp.app.settings.lang,
        theme: state.reportApp.app.settings.theme
    };
};

const mapDispatchToProps = {
    changeLang,
    changeTheme
};
export default connect(mapStateToProps, mapDispatchToProps)(withLocalization(HomePage));
